export enum Region {
  Europe = 10,
  America = 20,
  AsiaPacific = 30,
  Africa = 40
}
